import { render, staticRenderFns } from "./HomeSmallScreenSize.vue?vue&type=template&id=585d2b93&"
import script from "./HomeSmallScreenSize.vue?vue&type=script&lang=js&"
export * from "./HomeSmallScreenSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports